export default function archivedReportTypeDirective() {
  return {
    template: require('./report-type.html'),
    controller: 'ArchivedReportTypeController',
    controllerAs: 'archivedReportTypeVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      userId: '@',
      userName: '@',
      reportType: '=',
    },
  };
}
